<template>
    <div class="steps mb-5" v-if="links === 'true'">
        <router-link tag="div" class="step" v-for="index in +steps" :key="index" :class="[links && 'links', index == current && 'current', index < current && 'complete']" :to="'/registration/' + index"><span class="label" v-if="index == current">Step {{index}}</span></router-link>
    </div>

    <div class="steps mb-5" v-else>
        <div class="step" v-for="index in +steps" :key="index" :class="[index == current && 'current', index < current && 'complete']"><span class="label" v-if="index == current">Step {{index}}</span></div>
    </div>
</template>

<script>
export default {
    name: 'Steps',
    props: ['steps', 'current', 'links']
}
</script>

<style>

</style>
